import { Column, OutlinedCard, Row, Text, LabelWrapper } from "@bridgesplit/ui";
import { useMediaQuery } from "@mui/material";
import { COPY } from "app/constants";
import { DEFAULT_STRATEGY_DURATION, useStrategyDurations } from "@bridgesplit/abf-react";
import { formatDurationWithTypeShorthand } from "@bridgesplit/abf-sdk";
import { SelectStrategyDuration } from "app/components/common";
import { useSetLoopWindDuration } from "app/components/market-detail/borrow/util";

import WindAmount from "./WindAmount";
import WindMultiplier from "./WindMultiplier";
import WindStats from "./WindStats";
import WindCta from "./WindCta";
import WindNestedStats from "./WindNestedStats";
import { LOOP_DETAIL_QUERY } from "../detail";
import WindTopButtons from "./WindTopButtons";
import { useWindContext } from "./WindContext";

export function WindCard() {
    const isMobile = useMediaQuery(LOOP_DETAIL_QUERY.below);
    const { strategyDurations } = useStrategyDurations();
    const { form } = useWindContext();
    const { setLoopWindDuration } = useSetLoopWindDuration();

    return (
        <Column spacing={3}>
            <Column spacing={1}>
                <OutlinedCard hideCard={isMobile} spacing={3}>
                    <Row spaceBetween>
                        <Text variant="h4"> {COPY.LOOP_TERM_ACTION} </Text>
                        <WindTopButtons />
                    </Row>
                    <WindAmount />
                    <LabelWrapper
                        label="Fixed rate for"
                        tooltip={`Duration to lock your borrow APY for (defaults to ${formatDurationWithTypeShorthand(
                            DEFAULT_STRATEGY_DURATION.duration,
                            DEFAULT_STRATEGY_DURATION.durationType
                        )})`}
                    >
                        <SelectStrategyDuration
                            strategyDurations={strategyDurations}
                            strategyDuration={form.strategyDuration}
                            setStrategyDuration={setLoopWindDuration}
                        />
                    </LabelWrapper>
                    <WindMultiplier />
                    <WindNestedStats />
                    <WindCta />
                </OutlinedCard>
            </Column>

            <WindStats />
        </Column>
    );
}
